import { ClientRole, SiteAdminRole, SubAdminRole, UserAdminRole } from "../Component/Common/Constants/UserRoles";
import { ScorecardLicenseSummaryDataCore } from "../Component/Model/Dto/ScorecardLicense";
import {bbbeeModule} from "../Component/Common/Constants/routes";

export function getLinkTo(item: ScorecardLicenseSummaryDataCore, userRoles: string[], isGroup?: boolean, isSharedForVerification?: boolean): string {
    if (isGroup){
        return `/bee/groupDataManagementModule`;
    }
    if (isSharedForVerification){
        return `/${bbbeeModule.bee}/${bbbeeModule.verificationScorecards}/Open`;
    }
    if (userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole) || userRoles.includes(SubAdminRole)) {
        //Leaving the code like this because we we add the dashboard pages, we wont need to worry about what roles go where
        return `/bee/scorecardLicense`;
    } else if (userRoles.includes(ClientRole)) {
        return `/bee/scorecardLicense`;
    }
    else {
        return `/bee/scorecardLicense`;
    }
}